import React from 'react';
import { motion } from 'framer-motion';
export function ManifestoSection() {
  return <section className="w-full py-20 md:py-24 px-6 flex justify-center items-center" data-id="element-98">
      <motion.div initial={{
      opacity: 0,
      y: 60
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 1.2,
      ease: [0.2, 0.65, 0.3, 0.9]
    }} className="max-w-2xl mx-auto text-center" data-id="element-99">
        <p className="text-xl md:text-2xl lg:text-3xl text-forest leading-relaxed md:leading-relaxed lg:leading-relaxed tracking-wide" data-id="element-100">
          Las flores no son solo un regalo. Son un lenguaje, una forma de
          expresar lo que las palabras no alcanzan. En{' '}
          <span className="italic font-semibold" data-id="element-101">The Botanical Gallery</span>,
          cada arreglo es una obra de arte efímera — diseñada para emocionar,
          para transformar espacios y momentos en recuerdos.
        </p>
      </motion.div>
    </section>;
}